export default __webpack_public_path__ + "static/media/DB.7d287165.png";